<div style="padding: 0 15px">
  <form [formGroup]="formData">
    <!--*ngIf="group.name === 'relative'"-->
    <label>{{ question.label }}</label>

    <div class="col-lg-12">
      <ngx-dropzone
        [multiple]="false"
        [expandable]="false"
        accept="image/jpeg,image/jpg,image/png,image/gif">
        <ngx-dropzone-label>5X7 JPG or PNG</ngx-dropzone-label>
        <ngx-dropzone-image-preview
          *ngIf="firstMedia.file"
          [file]="firstMedia.file"
          [removable]="true"
          (removed)="onRemoveLogo(firstMedia)"
          ngProjectAs="ngx-dropzone-preview">
          <ngx-dropzone-label
            >{{ firstMedia.name }} ({{
              firstMedia.file.type
            }})</ngx-dropzone-label
          >
        </ngx-dropzone-image-preview>
        <div
          class="ngx-dropzone-image-preview"
          *ngIf="firstMedia.url"
          [ngStyle]="{
            backgroundImage: 'url(' + firstMedia.url + ')'
          }"></div>
      </ngx-dropzone>
    </div>
  </form>
</div>
